import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "no.icon",
  "use": "no.icon-usage",
  "viewBox": "2155.886 12994.883 29.16 29.16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"2155.886 12994.883 29.16 29.16\" id=\"no.icon\"><defs><style>#no.icon .cls-1{fill:#e3849b}</style></defs><g id=\"no.icon_Group_494\" data-name=\"Group 494\" transform=\"translate(643 12172)\"><rect id=\"no.icon_Rectangle_477\" data-name=\"Rectangle 477\" class=\"cls-1\" width=\"35.845\" height=\"5.393\" rx=\"2.696\" transform=\"rotate(-45 1780.346 -1402.1)\" /><rect id=\"no.icon_Rectangle_478\" data-name=\"Rectangle 478\" class=\"cls-1\" width=\"35.845\" height=\"5.393\" rx=\"2.696\" transform=\"rotate(45 -234.958 2242.26)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/no.icon.svg
// module id = LALb
// module chunks = 13